import isWithinInterval from 'date-fns/isWithinInterval';

export const formatDate = (dateObj: number | Date | undefined, formatType?: string) : string => {
  const year = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(dateObj);
  const month = new Intl.DateTimeFormat('en', { month: '2-digit' }).format(dateObj);
  const day = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(dateObj);
  return formatType === 'fns' ? `${year}/${month}/${day}` : formatType === 'dots' ? `${day}.${month}.${year}` : `${year}-${month}-${day}`;
};

export const formatDateAndTime = (dateObj : number | Date | undefined, formatType?: string): string => {
  const date = formatDate(dateObj, formatType);
  const time = new Intl.DateTimeFormat('en', { hour: 'numeric', minute: 'numeric', second: 'numeric', hourCycle: 'h23' }).format(dateObj);
  return `${date} ${time}`;
};

export const createPreciseDate = (date: string | Date): Date => {
  if (typeof date === 'string') {
    return new Date(date + 'T00:00:00');
  }
  return new Date(date);
};

export const doesPeriodContainToday = (startDate: string, endDate: string) => {
  const todayDateStr = formatDate(new Date());
  return isWithinInterval(new Date(todayDateStr), {
    start: new Date(startDate),
    end: new Date(endDate)
  });
};

const months = [
  'JANUARY',   'FEBRUARY',
  'MARCH',     'APRIL',
  'MAY',       'JUNE',
  'JULY',      'AUGUST',
  'SEPTEMBER', 'OCTOBER',
  'NOVEMBER',  'DECEMBER'
];

export const getMonthnameByIndex = (index: number) => months[index % 12];
export const getIndexByMonthname = (monthName: string) => months.findIndex(i => i === monthName);
 